import { z } from 'zod';
import { Topic } from './Topic';

export const topicListExample = z.array(Topic).parse([
  // 50個分のデータを作る。createdAt, updatedAtは1日ずつずらす。
  ...Array.from({ length: 50 }, (_, i) => ({
    id: `topic-${i}`,
    locationId: 'location-0',
    title: `トピック ${i}`,
    text: `トピック ${i} の説明`,
    authorId: 'user-0',
    eyeCatchURL: `https://picsum.photos/seed/topic${i}/200`,
    bannerURL: `https://picsum.photos/seed/topic${i}/400/200`,
    draft: i % 4 === 0,
    createdAt: new Date(Date.UTC(2021, 1, 1 + i, 0, 0, 0, 0)).toISOString(),
    updatedAt: new Date(Date.UTC(2021, 1, 1 + i, 0, 0, 0, 0)).toISOString(),
    publishedAt: new Date(Date.UTC(2021, 1, 1 + i, 0, 0, 0, 0)).toISOString(),
  })),
]);
